module.exports = __webpack_public_path__ + "static/media/WiCanvas5.fc0bc4ef.jpg";